import { useMemo } from 'react';

import { type JustifiedBox } from '@air/component-gallery-view';

import { createJustifiedBoxes, type UseCSSGridLikeLayoutProps } from './useCSSGridLikeLayout';

export type UseCSSGridLikeLayoutsForMultiSectionsProps = {
  sections: UseCSSGridLikeLayoutProps[];
};

export default function useCSSGridLikeLayoutsForMultiSections(props: UseCSSGridLikeLayoutsForMultiSectionsProps) {
  const boxesSections: JustifiedBox[][] = useMemo(() => {
    return props.sections.map((s) => createJustifiedBoxes(s));
  }, [props.sections]);

  return { sections: boxesSections };
}
